import React, { useState } from 'react';
import {Grid, Typography, TextField} from '@mui/material';
import {makeStyles} from "@mui/styles";
import {useNavigate} from "react-router-dom";

import {colorLabel, Button, SubTitle} from '../'
import AccountsService from "../../services/accounts"

const useStyles = makeStyles(() => ({
  rowLabel: {
    color: colorLabel,
  },
  table: {
    marginTop: 17,
    '& td': {
      paddingTop: 7,
      paddingBottom: 7,
      border: 'none',
    },
    '& td:first-child': {
      paddingLeft: 0,
      width: 90,
    },
  },
  saveButton: {
    width: 120,
    height: 37,
    marginRight: 164,
    marginTop: 16,
    fontSize: 13,
    fontWeight: 500,
  },
}));

const PasswordForm = (props: any) => {
    const {text, value, setValue} = props;
    
    return(
        <Grid item>
            <Grid container spacing={5}>
                <Grid item>
                    <Typography variant={"subtitle1"} sx={{fontWeight: "bold", mt: 2}}>{text}</Typography>
                </Grid>
                <Grid item>
                    <TextField value={value} onChange={(e: any) => setValue(e.target.value)} sx={{width: "330px"}} type={"password"}/>
                    </Grid>
                </Grid>
        </Grid>
    )
}

export const ChangePassword = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState<string>("");
    const [checkPassword, setCheckPassword] = useState<string>("");


    const changePassword = (): void => {
        if (newPassword === checkPassword && /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^~*+=]).{8}/.test(newPassword)){
            const accounts = new AccountsService(navigate);
            accounts.changePassword(newPassword)
            .then(() => {alert("비밀번호가 변경되었습니다.\n다음 접속부터 새로운 비밀번호로 로그인해주세요.")})
            .catch(() => {alert("비밀번호가 변경되지 않았습니다.\n운영자에게 문의해주세요.")})
            
        }
        else {
            alert("비밀번호가 다르거나 유효성이 맞지않습니다.\n영어, 숫자, 특수문자가 8자리 이상이어야합니다.")     
        }
    }

    
    return(
        <>
            <Grid container direction="column" spacing={3} sx={{pt: 3, width: "700px"}}>
                <PasswordForm text={"새로운 비밀번호"} value={newPassword} setValue={setNewPassword}/>
                <Typography sx={{ml: 20, mt:1, color: "red"}}>숫자, 문자, 특수문자를 조합하여 8자리 이상이어야합니다.</Typography>
                <PasswordForm text={"비밀번호 재입력"} value={checkPassword} setValue={setCheckPassword}/>

                <Grid item sx={{ml: 43}}>
                    <Button size="large" variant="contained" className={classes.saveButton} onClick={changePassword}>변경하기</Button>
                </Grid>
            </Grid>
        </>
    )
}